export class TopUpTicketPostModel {
  public amount: number;

  constructor(
    public barcodeText: string,
    public barcodeACN: number,
    public gameNumber: number,
    public area: string,
    public row: string,
    public seat: string,
    public balance: number,
    public stand: string,
    public gameDate: Date
  ) {}
}
